import { Collapse } from 'react-bootstrap';

import { EditableSettings } from 'components/EditableSettings/EditableSettings';
import { Input, ToggleLabel } from 'components/FormComponents';

export const DefaultSettings = ({ register, name, field }) => (
  <EditableSettings title="Settings" className="u-margin-top" startOpen={true}>
    <ToggleLabel register={register} name={`${name}.required`} label="Required" />
    <div className="d-flex flex-column u-margin-top--small">
      <span className="u-text-small u-text-muted">Placeholder</span>
      <Input
        register={register}
        name={`${name}.placeholder`}
        className="u-margin-top--small"
        placeholder="Enter placeholder..."
      />
    </div>
    <div className="u-divider u-margin-y--small" />
    <>
      <ToggleLabel register={register} name={`${name}.use_description`} label="Add description" />
      <Collapse in={field.use_description}>
        <div>
          <Input
            register={register}
            name={`${name}.description`}
            className="u-margin-top--small"
            placeholder="Enter description..."
          />
        </div>
      </Collapse>
    </>
  </EditableSettings>
);
